<div class="container-fluid h-100">
    <div class="row h-100 bg-white">
        <!-- Login component -->
        <div class="mx-auto" [ngClass]="{'col-4' : desktopQuery.matches, 'col-10' : !desktopQuery.matches}">
            <form class="row mt-5" [formGroup]="loginForm" (ngSubmit)="onSubmit()">
                <h1 class="mb-1">Log in to your account</h1>
                <p class="fw-light mb-3">Welcome back! Enter your credentials to access your account</p>
                <div class="col-12 mb-3">
                    <mat-form-field appearance="outline" class="w-100">
                        <mat-label>Email address</mat-label>
                        <mat-error *ngIf="getF()['email'].hasError('required')">Field cannot be empty</mat-error>
                        <mat-error *ngIf="getF()['email'].hasError('email')">You need to enter a valid email</mat-error>
                        <input matInput placeholder="example@example.com" formControlName="email" autocomplete="on" required>
                        <mat-hint>Email</mat-hint>
                    </mat-form-field>
                </div>

                <div class="col-12 mb-3">
                    <mat-form-field appearance="outline" class="w-100">
                        <mat-label>Enter your password</mat-label>
                        <mat-error *ngIf="getF()['password'].hasError('required')">Field cannot be empty</mat-error>
                        <input matInput [type]="hide ? 'password' : 'text'" formControlName="password" required>
                        <button type="button" mat-icon-button matSuffix (click)="hide = !hide" [attr.aria-label]="'Hide password'"
                            [attr.aria-pressed]="hide">
                            <mat-icon>{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
                        </button>
                        <mat-hint>Password</mat-hint>
                        <mat-hint align="end"><a [routerLink]="lostPasswordPath">Forgot your password?</a></mat-hint>
                    </mat-form-field>
                </div>

                <div class="col-12">
                    <button type="submit" [disabled]="!loginForm.valid" mat-raised-button color="primary"
                        class="mx-auto d-block w-100">
                        <span *ngIf="!isLoginLoading">Login</span>
                        <mat-spinner *ngIf="isLoginLoading" [diameter]="30" [strokeWidth]="3"
                            class="mx-auto mat-spinner"></mat-spinner>
                    </button>
                </div>
            </form>

            <!-- Button section -->
            <div class="row">
                <div class="col-12 d-flex align-items-center mt-3 mb-3">
                    <span class="line"></span> OR <span class="line"></span>
                </div>

                <div class="col-12">
                    <button (click)="onGoogleLogin()" mat-button extended class="mx-auto w-100 border" style="border-color: #E0E0E0;">
                        <mat-icon class="h-100" svgIcon="google">google</mat-icon>
                        Continue with Google
                    </button>
                </div>
            </div>

            <!-- Sign up section -->

            <div class="row mt-5">
                <div class="col-12">
                    <p class="text-center text-secondary">New to pulsy? <a [routerLink]="signUpPath">Get Started</a></p>
                </div>
            </div>
        </div>


        <!-- Image on the side -->

        @if(desktopQuery.matches) {
        <div class="col-6 border border-dark image-side">
        </div>
        }
    </div>
</div>